<!-- <div
  id="dashboard-modal"
  class="modal fade-scale in"
  role="dialog"
  style="background-color: rgba(0, 0, 0, 0.1); display: block"
> -->

<div class="modal-content error-modal-content">
  <div class="modal-body">
    <h4 id="heading-modal" class="head-modal">
      The email address entered already has an account associated with it.
    </h4>
    <hr class="modal-hr-line" />
    <p id="err-recurly-modal-body" class="inbody-modal"></p>
    <p class="inbody-modal">
      To use the existing account to add maps or other services,<a
        href="/login"
      >
        log in</a
      >
      to view your account, then click SUBSCRIBE.
    </p>
    <p class="inbody-modal">
      To create a new account using a different email address, click OK and
      enter the new email address.
    </p>
    <div class="btn-container" style="text-align: right">
      <button
        type="button"
        class="btn accept-btn gernal-btn"
        data-dismiss="modal"
        style="float: right; border-radius: 0px; margin-top: 10px"
        (click)="closeDialog()"
      >
        OK
      </button>
    </div>
    <br />
    <br />
    <br />
  </div>
</div>
<!-- </div> -->
